import "./App.css";
import React from "react";
import Routers from "./routes";
import NoInternetConnection from "./components/noInternetConnection";
import { useUser } from "./config/userProvider";
import { PdfProvider } from "./pages/createCatalog/pdfContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// // import logo from "./logo.svg";
// import InstallPWA from "./config/installPwa";
// import { ThemeProvider } from "./config/themeContext";
import "./global.css";

function App() {
  const { showInternetStatus } = useUser();
  // const token = localStorage.getItem("sctoken");

  return (
    <React.Fragment>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
      />
      <PdfProvider>
        <NoInternetConnection />
        {showInternetStatus && (
          <div
            style={{ borderWidth: 1 }}
            className="z-50 absolute left-1/2 top-2 translate-x-[-50%] font-semibold p-1 px-4 rounded-md text-red-700 bg-red-100 border-red-600"
          >
            Network disconnect
          </div>
        )}
        <Routers />
      </PdfProvider>
    </React.Fragment>
  );
}

export default App;
